<template>
    <div style="height: 100%;">
        <div id="main" v-show="!rotaAninhada">
            <container-loader
                v-if="isLoading && !$store.getters.isLoading"
            />
            <div class="page">
                <div class="vertical-flow">
                    <!-- TÍTULO -->
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t("categorias") }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("vendas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("cadastros")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("categorias")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !tabelaIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({ name: 'ven-categoria-new' })
                                "
                            >
                                {{ $t("adicionar") }}
                            </button>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-9">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>
                        <div
                            class="column is-3">
                            <vss-select
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacaoSelect"
                                v-model="situacaoSelected"
                                mlLabels
                                title="situacao"
                                clearable
                                @input="onSituacaoChanged"
                                :height="40"
                            />
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="allcategorias"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="
                                    f.key != 'excluir' ? $t(f.key) : ''
                                "
                                :width="f.width"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                                :class="{
                                    'excluir-field': f.key == 'excluir',
                                }"
                            >
                                <div v-if="f.key == 'idcategoriaerp'">
                                    <pre>{{ props.row[f.key] }}</pre>
                                </div>
                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: 'ven-categoria-edit',
                                            params: {
                                                id: props.row.idcategoria,
                                            },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'categoriapai'">
                                    <pre>{{ props.row[f.key] }}</pre>
                                </div>
                                <div v-else-if="f.key == 'excluir'" >
                                    <b-button
                                        v-if="
                                            permissao.delete &&
                                            !tabelaIntegracao
                                        "
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1
                                                ? 'delete'
                                                : 'check'
                                        "
                                        @click="
                                            promptChangeSituacao(
                                                props.row
                                            )
                                        "
                                        v-tippy 
                                        :title="$t(
                                            props.row['situacao'] == 1
                                                ? 'desativar'
                                                : 'reativar'
                                        )"
                                    />
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <b-tag
                                        v-if="props.row[f.key] == 1"
                                        class="table-tag table-tag-full-width"
                                        type="is-success"
                                        size="is-medium"
                                    >
                                        {{ $t("ativo") }}
                                    </b-tag>
                                    <b-tag
                                        v-else
                                        class="table-tag table-tag-full-width"
                                        type="is-danger"
                                        size="is-medium"
                                    >
                                        {{ $t("inativo") }}
                                    </b-tag>
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import CategoriaService from "@/services/CategoriaService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes("ven-categoria") &&
            to.name != "ven-categoria-list"
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
    },
    data() {
        return {
            allcategorias: [],
            situacao: { id: 4, label: "todos" },
            service: new CategoriaService(this.$http, this.$router),
            tabelaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("CATEGORIA"),
            permissao: {},
            fields: [
                {key: "idcategoriaerp", width: '10%', sortable: true, sortFn: null },
                { key: "descricao", width: null, sortable: true, sortFn: null },
                { key: "categoriapai", width: 300, sortable: true, sortFn: null },
                { key: "situacao", width: 70, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            queryFilter: "",
            sort: "descricao",
            order: "asc",
            deleteThis: {},
            delete: null,
            situacaoSelected: { id: 4, label: "todos" },
            situacaoSelect: [
                { id: 4, label: "todos" },
                { id: 0, label: "inativos" },
                { id: 1, label: "ativos" },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        if (
            this.$route.name.includes("ven-categoria") &&
            this.$route.name != "ven-categoria-list"
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-categoria"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "categoria" },
            });
            
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        sortTable(field, order) {
            this.sort = field;
            this.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.situacaoSelected.id,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.order,
                    this.sort,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allcategorias = value;
                    this.isEmpty = this.allcategorias.length <= 0;
                })
                .catch((e) => {
                    console.error("Erro ao carregar listagem de categorias.", e);
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load-categoria");
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val 
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    idcategoria: m.idcategoria,
                    idcategoriaerp: m.idcategoriaerp,
                    descricao: m.descricao,
                    situacao: m.situacao,
                    categoriapai: m.categoriapai,
                    idcategoriapai: m.idcategoriapai,
                };
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let categoria = {
                idcategoria: this.delete.idcategoria,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(categoria)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 0
                                    ? "msg-sucesso-ao-desativar-categoria"
                                    : "msg-sucesso-ao-reativar-categoria", 
                                { n: this.$t("categoria") }
                            );

                        this.$root.showMessage("success",tempSuccess,true,false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage("error","Erro ao atualizar status.");
                    }
                })
                .catch((e) => {
                    let messageFail = this.$t(
                            this.delete.situacao == 1
                                ? "msg-erro-ao-desativar-categoria"
                                : "msg-erro-ao-reativar-categoria", 
                            { n: this.$t("categoria") }
                        );

                    this.$root.showMessage("error", messageFail, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;
        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
    }

    .data-table {
        padding: 0;
    }

    .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;

        .search-bar {
            width: 100%;
        }
    }
}
</style>